export const diagonistics=[
    {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },
      {
         id:1,
        name:"Peerless super speciality Hospital",
        Address:"123, Abc Road, Block-c, Kalyani,Nadia",
        TestProvided:["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""],
        Registered:"01-11-2021",
        Doctors:["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"],
        Patients:2000
    },

]